import useTestTag from '../../common/hooks/use-test-tag';

interface FieldLabelProps {
  label: string;
  name?: string;
  labelStyles?: string;
}

export default function FieldLabel({ label, name, labelStyles }: FieldLabelProps) {
  const tagCreator = useTestTag(label || '');

  return (
    <label className={labelStyles ?? 'block text-sm font-bold'} htmlFor={name} ref={tagCreator('label')}>
      {label}
    </label>
  );
}
